/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".list{display:flex;flex-direction:column}.list--default app-list-item{display:list-item;margin-left:16px;list-style-type:disc}.list--commafied{align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;padding:0 4px 4px 0}.list--commafied app-list-item:not(:last-child):after{content:\", \";float:right;padding-right:4px}.list--flat app-list-item:not(:last-child){margin-bottom:4px}.list__item{display:block}"];
export { styles as styles };
